export const COLOR_MAP = {
  white: "#FFFFFF", blanco: "#FFFFFF",
  black: "#222222", negro: "#222222",
  red: "#E53935", rojo: "#E53935",
  green: "#43A047", verde: "#43A047",
  blue: "#1E88E5", azul: "#1E88E5",
  yellow: "#FDD835", amarillo: "#FDD835",
  gray: "#9E9E9E", grey: "#9E9E9E", gris: "#9E9E9E",
  silver: "#C0C0C0", plata: "#C0C0C0", plateado: "#C0C0C0",
  orange: "#FB8C00", naranja: "#FB8C00",
  brown: "#795548", cafe: "#795548", marron: "#795548",
  beige: "#D7CCC8",
  gold: "#D4AF37", dorado: "#D4AF37",
};

export const COLOR_ALIASES = {
  grey: "gray", gris: "gray",
  blanco: "white", negro: "black", rojo: "red", verde: "green", azul: "blue",
  amarillo: "yellow", plata: "silver", plateado: "silver", naranja: "orange",
  cafe: "brown", marron: "brown", dorado: "gold",
};

export const UNKNOWN_COLOR = "#B0BEC5";

export const REPORT_COLORS = [
  "red", "green", "blue", "white", "black", "yellow",
  "gray", "silver", "orange", "brown", "beige", "gold",
];
